import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import './register-hooks';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
		},
		{
			path: '/locations',
			name: 'locations',
			component: () => import(/* webpackChunkName: "locations" */ './views/Locations.vue'),
		},
		{
			path: '/my-dashboard',
			name: 'my-dashboard',
			component: () => import(/* webpackChunkName: "my-dashboard" */ './views/MyDashboard.vue'),
		},
		{
			path: '/automated-ai-marketing/:base',
			props: true,
			name: 'automated-ai-marketing',
			component: () => import(/* webpackChunkName: "automated-ai-marketing" */ './views/AutomatedAIMarketing.vue'),
		},
		{
			path: '/flash-offers',
			name: 'flash-offers',
			component: () => import(/* webpackChunkName: "flash-offers" */ './views/FlashOffers.vue'),
		},
		{
			path: '/billing',
			name: 'billing',
			component: () => import(/* webpackChunkName: "billing" */ './views/Billing.vue'),
		},
	],
});

// Load Google Maps if not loaded
class GoogleMapsLoader {
	public loaded = false;

	async load() {
		console.log('Loading Google Maps Key');
		const apiKey = await this.getApiKey();
		console.log('Key Loaded');
		Vue.use(VueGoogleMaps, {
			load: {
				key: apiKey,
				libraries: 'places,geometry',
			}
		});
		console.log('VueGoogleMaps Loaded');
		this.loaded = true;
	}

	async getApiKey() {
		await this.sleep(1000);
		return 'AIzaSyASNUQCfOLfdoL_MTUbSgsY3F0xoWB6qEk'; // Found in pd2_extended_profile.php
	}

	// TODO: Remove this once we are really calling out for the key
	sleep(ms: number) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}
}

const googleMapsLoader = new GoogleMapsLoader();
router.beforeEach((to, from, next) => {
	if (!googleMapsLoader.loaded) {
		googleMapsLoader.load().then(() => {
			next();
		});
	} else {
		next();
	}
});


export default router;
